__turbopack_context__.v({
  "searchBarSkeleton": "SearchBar-module-scss-module__WPMpDW__searchBarSkeleton",
});
